import React, { PureComponent } from 'react';

class MobileTeaser extends PureComponent {
  render() {
    return (
      <div className="mobileteaser">
        <a className="mobileteaser__link" href={baseconfig.teaserLink} target="_blank">Alle Ergebnisse für Deutschland und Europa →</a>
      </div>
    );
  }
}

export default MobileTeaser;
